import { useCallback, useState } from 'react';

import { useForm } from '@dansk-metal/ui';

import { PaginationParams } from '@web/components/pagination/hooks/use-pagination';
import { Pagination } from '@web/components/pagination/pagination';

import { getApiSearchPublications, PublicationsSearchResult } from '@web/services/umbraco/rest';


type PublicationItems = PublicationsSearchResult['items'];

type UsePublicationSearchFormParams = Pick<PaginationParams, 'limit'> & {
	publications: PublicationsSearchResult;
	pathname?: string;
};

export function usePublicationSearchForm({ publications: { items, total: totalItems }, pathname, limit }: UsePublicationSearchFormParams) {
	const [total, setTotal] = useState(totalItems);
	const [publications, setPublications] = useState<PublicationItems>(items);
	const pagination = Pagination.usePagination<PublicationItems>({ limit, total });
	const form = useForm({ defaultValues: { text: '', tag: '' } });

	function setTagValue({ value, shouldDirty = true }: { value: string; shouldDirty?: boolean }) {
		form.setValue('tag', value, { shouldDirty });
	}

	const submit = useCallback(async (data) => {
		const res = await getApiSearchPublications({
			...data,
			limit: pagination.limit,
			skip: pagination.offsetItems,
			route: pathname,
		});

		setPublications(res.items);
		setTotal(res.total);
	}, [pagination.offsetItems, pagination.limit]);

	return {
		...form,
		publications,
		pagination,
		submit,
		setTagValue,
	};
}

